import smCrypto from "sm-crypto";

const API_BASE_URL = (import.meta.env.VITE_API_BASEURL || "/api").replace(/\/$/, "");
export const MARKET_TOKEN_KEY = "market_token";
const SM2_PUBLIC_KEY =
  "04298364ec840088475eae92a591e01284d1abefcda348b47eb324bb521bb03b0b2a5bc393f6b71dabb8f15c99a0050818b56b23f31743b93df9cf8948f15ddb54";

type AuthResponse<T> = { code: number; msg?: string; data: T };

const encryptPassword = (password: string) =>
  smCrypto.sm2.doEncrypt(password, SM2_PUBLIC_KEY, 1);

export async function request<T>(path: string, body?: Record<string, string>): Promise<T> {
  const token = localStorage.getItem(MARKET_TOKEN_KEY);
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: body ? "POST" : "GET",
    headers: { "Content-Type": "application/json", ...(token ? { token } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  let result: AuthResponse<T>;
  try {
    result = await response.json();
  } catch {
    throw new Error("服务器返回了无法识别的数据");
  }
  if (!response.ok || result.code !== 200) {
    throw new Error(result.msg || "请求失败，请稍后重试");
  }
  return result.data;
}

export async function uploadCFile(file: File): Promise<{ url: string }> {
  const formData = new FormData();
  formData.append("file", file);
  const token = localStorage.getItem(MARKET_TOKEN_KEY);
  const response = await fetch(`${API_BASE_URL}/C/file/uploadFile`, {
    method: "POST",
    headers: token ? { token } : {},
    body: formData,
  });

  let result: AuthResponse<{ url: string }>;
  try {
    result = await response.json();
  } catch {
    throw new Error("服务器返回了无法识别的数据");
  }
  if (!response.ok || result.code !== 200 || !result.data?.url) {
    throw new Error(result.msg || "文件上传失败，请稍后重试");
  }
  return result.data;
}

export function login(account: string, password: string) {
  return request<string>("/auth/c/doLogin", { account, password: encryptPassword(password) });
}

export function register(account: string, password: string, nickname: string) {
  return request<string>("/auth/c/registerNew", {
    account,
    password: encryptPassword(password),
    nickname,
  });
}

export function getLoginUser() {
  return request<{ account?: string; name?: string; nickname?: string }>("/auth/c/getLoginUser");
}
